export default __webpack_public_path__ + "static/media/mp3.5bfc2556.svg";